var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "bullhorn", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c("v-container", { attrs: { fluid: "" } }, [
        _c(
          "div",
          { staticClass: "news-wall" },
          [
            _vm.create_access
              ? _c(
                  "v-btn",
                  {
                    staticClass: "mb-5",
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openModal(null)
                      },
                    },
                  },
                  [_vm._v("Nueva novedad")]
                )
              : _vm._e(),
            _vm.loading && _vm.list.length == 0
              ? _c(
                  "div",
                  { staticClass: "pa-6 text-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", color: "primary" },
                    }),
                  ],
                  1
                )
              : _vm.load_error
              ? _c(
                  "div",
                  { staticClass: "news-wall__empty" },
                  [
                    _c("p", [_vm._v("No se pudieron cargar las novedades.")]),
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "", color: "primary" },
                        on: { click: _vm.reload },
                      },
                      [_vm._v("Reintentar")]
                    ),
                  ],
                  1
                )
              : _vm.list.length == 0
              ? _c(
                  "div",
                  { staticClass: "news-wall__empty" },
                  [
                    _c(
                      "v-icon",
                      { attrs: { large: "", color: "grey lighten-1" } },
                      [_vm._v("mdi-bullhorn-outline")]
                    ),
                    _c("p", [_vm._v("Todavía no hay novedades.")]),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "news-wall__list" },
              _vm._l(_vm.list, function (item) {
                return _c("NewsCard", {
                  key: item.id,
                  attrs: {
                    item: item,
                    can_update: _vm.update_access,
                    can_delete: _vm.delete_access,
                  },
                  on: { edit: _vm.openModal, remove: _vm.askRemove },
                })
              }),
              1
            ),
            _vm.list.length < _vm.total
              ? _c(
                  "div",
                  { staticClass: "text-center mt-4" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          text: "",
                          color: "primary",
                          loading: _vm.loading,
                        },
                        on: { click: _vm.load },
                      },
                      [_vm._v("Ver más")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.create_access || _vm.update_access
        ? _c("ModalNews", {
            attrs: { dialog: _vm.dialog, item: _vm.editing },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
              saved: _vm.onSaved,
            },
          })
        : _vm._e(),
      _c("DialogDelete", {
        attrs: { dialog_delete: _vm.dialog_delete },
        on: {
          updateDialogDelete: function ($event) {
            _vm.dialog_delete = false
          },
          deleteItemConfirm: _vm.remove,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }